import { cookieManager } from 'src/services/cookies';

const FB_UTM_SOURCES = ['facebook', 'meta'];
const TIKTOK_UTM_SOURCES = ['tiktok'];
const TIMEOUT_DELAY = 3000;

type AdsData = {
  channel: string;
  click_id: string;
  pixel_id?: string;
  fbp?: string;
  fbc?: string;
  ttclid?: string;
};

const getAdsData = async (queryParams: Record<string, unknown>): Promise<AdsData> => {
  const adsData: AdsData = {
    channel: (queryParams?.utm_source as string) || '',
    click_id: (queryParams.clickid as string) || '',
  };

  if (FB_UTM_SOURCES.includes((queryParams?.utm_source as string)?.toLowerCase())) {
    try {
      const [fbpid, fbclid] = await Promise.all([
        cookieManager.waitForCookie('_fbp', TIMEOUT_DELAY),
        cookieManager.waitForCookie('_fbc', TIMEOUT_DELAY),
      ]);

      adsData.pixel_id = process.env.REACT_APP_FACEBOOK_PIXEL_ID || '';
      adsData.fbp = fbpid || (queryParams.fbp as string) || '';
      adsData.fbc = fbclid || (queryParams.fbclid as string) || '';
    } catch (error: unknown) {
      console.error('Failed to retrieve Facebook cookies:', error);
    }
  }

  if (TIKTOK_UTM_SOURCES.includes((queryParams?.utm_source as string)?.toLowerCase())) {
    adsData.pixel_id = process.env.REACT_APP_TIKTOK_PIXEL_ID || '';
    adsData.ttclid = (queryParams.ttclid as string) || '';
  }

  return adsData;
};

export { getAdsData };
